import { render, staticRenderFns } from "./valuedatareported.vue?vue&type=template&id=18efffb6&"
import script from "./valuedatareported.vue?vue&type=script&lang=js&"
export * from "./valuedatareported.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports